/**
 * This file is generated from scripts/genIconComponents.js. Any
 * changes should be made in that file.
 */
import React, { forwardRef, Ref } from "react";
import { getSvgResourceForSize, getDefaultSize } from "../../utils";
import { Icon, LodestarIconProps } from "../../icon";
import { SvgPaginationLastPage as PaginationLastPageMedium } from "./medium/PaginationLastPage";
const sizeMap = {
    medium: PaginationLastPageMedium,
};
const defaultSize = getDefaultSize(sizeMap);

export const PaginationLastPageIcon = forwardRef(
    (
        { size = defaultSize, ...rest }: LodestarIconProps,
        ref: Ref<HTMLElement>
    ) => (
        <Icon
            ref={ref}
            svgComponent={getSvgResourceForSize(sizeMap, size)}
            size={size}
            {...rest}
        />
    )
);
PaginationLastPageIcon.displayName = "PaginationLastPageIcon";
